import { render, staticRenderFns } from "./PackagedProductDiscard.vue?vue&type=template&id=70b22d3d"
import script from "./PackagedProductDiscard.vue?vue&type=script&lang=js"
export * from "./PackagedProductDiscard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports